import React, { useEffect, useState } from 'react';
import AppStorage from 'easy-app-storage';
import { QueryClient, QueryClientProvider } from 'react-query';
import Theme from '../../configs/theme';

import {
    MultiProvider,
    ApiProvider,
    storageOptions,
    I18nProvider,
    StorageProvider,
    api,
    SpringBigThemeProvider,
    SpringBigStoreProvider,
    AppSettingsProvider,
    StashboardProvider,
    ThemeOverrides,
    ClientType,
    CONFIG_URL,
    DutchieStoreProvider, useI18n,
} from '@springbig/shared';

import AppRoutes from './routes';
import SplashScreen from './shared/SplashScreen/SplashScreen';
import { useEffectOnce } from 'usehooks-ts';

const appStorage = new AppStorage(localStorage, storageOptions);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0
        }
    }
});

const App = () => {

    const [settings, setSettings] = useState<any>();
    const [languageEdit, setLanguageEdit] = useState();
    const [language, setLanguage] = useState();
    const [client, setClient] = useState<ClientType>();
    const [theme, setTheme] = useState<ThemeOverrides>();
    const [isConfigsLoading, setIsConfigLoading] = useState<boolean>(false);

    const setDevMerchantOrg = (): void => {

        const queryParams = new URLSearchParams(window.location.search);
        const paramValue = queryParams.get('merchant');
        if (paramValue) {
            localStorage.setItem('dev:merchant', JSON.stringify(paramValue));
        }

        const savedMerchant = localStorage.getItem('dev:merchant');

        if (process.env.NODE_ENV === 'development' && localStorage.getItem('dev:merchant')) {
            setClient(JSON.parse(savedMerchant) as ClientType);
        }
        else {
            setClient('zaharaCannabis');
        }
    };

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await fetch(process.env.PUBLIC_URL + '/static/data.json');
                const data = await response.json();
                setClient(data.clientName);
            }
            catch (error) {
                setDevMerchantOrg();
                console.error('Error fetching JSON data:', error);
            }
        };

        fetchData();

    }, [process.env.PUBLIC_URL]);

    const loadJsonData = async () => {

        try {

            if (client) {

                setIsConfigLoading(true);

                // inhibiting app settings as part of PMO-14302
                // const _settings = await api.get(`/native_app/v1/app_settings?name=${client}`);

                // if (_settings) {
                //     setIsConfigLoading(false);
                //
                //     setTheme(Theme(_settings.darkOverride, _settings.lightOverride, _settings.theme));
                //     setSettings({
                //         bottomNav: _settings.bottomNav,
                //         sideNav: _settings.sideNav,
                //         merchantOrg: _settings.merchantOrg,
                //         ..._settings.settings,
                //         appTitle: _settings.appTitle
                //     });
                //     setLanguageEdit(_settings.englishOverride as any);
                //     setLanguage(_settings.englishOverride);
                // }
                // else {

                // this is a temporary fallback, remove the entire else block once v3 transition has succeeded
                console.log(`[important] App.tsx line 170: ${client}'s app settings could not be loaded from database, reverting to cloudfront`);
                const BASE_URL = `${CONFIG_URL}/${client.toLowerCase()}`;

                const _settings = await fetch(`${BASE_URL}/configs/settings.json`);
                const _theme = await fetch(`${BASE_URL}/configs/colors.json`);
                const _language = await fetch(`${BASE_URL}/configs/language.json`);
                const _languageEdit = await fetch(`${BASE_URL}/configs/languageEdit.json`);

                const themeJson = await _theme.json();
                const settingsJson = await _settings.json();
                const languageJson = await _language.json();
                const languageEditJson = await _languageEdit.json();


                setIsConfigLoading(false);

                setTheme(Theme(themeJson.dark, themeJson.light, themeJson.colors));
                setSettings(settingsJson);
                setLanguageEdit(languageEditJson as any);
                setLanguage(languageJson as any);
                // }

                if (settingsJson.languages && settingsJson.languages.length > 0) {

                    settingsJson.languages.map(lang => {

                        if (lang.default) {
                            setLanguage(lang.i18n);
                        }
                    });
                }
            }
        }
        catch (error) {
            console.error('Error loading JSON:', error, client);
        }
    };

    useEffect(() => {

        loadJsonData();
    }, [client]);

    const updateMerchant = (clientType: ClientType) => {

        setClient(clientType);
    };

    // if (isConfigsLoading) {
    //     return <SplashScreen />;
    // }

    return (
        <MultiProvider
            providers={[
                <QueryClientProvider client={queryClient} key={0} />,
                <StorageProvider storage={appStorage} key={1}  />,
                <SpringBigStoreProvider queryClient={queryClient} key={2}  />,
                <ApiProvider api={api} key={3}  />,
                <SpringBigThemeProvider themeConfig={theme} key={4}  />,
                <I18nProvider language={language || {}} languagesEdit={languageEdit || {}} key={5}  />,
                <AppSettingsProvider {...settings} key={6}  />,
                <StashboardProvider key={7}  />,
                <DutchieStoreProvider key={8}  />
            ]}
        >
            <AppRoutes updateMerchant={updateMerchant} />
        </MultiProvider>
    );
};

export default App;
// export default Config;
